/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useRequester } from '../../hooks';
import ScenarioResource, { ScenarioData } from '../../resources/ScenarioResource';
import ScenarioForm from './ScenarioForm';
import { Page } from '../../design';
import { AuthContext } from '../../contexts';
import ParticipantResource from '../../resources/ParticipantResource';

export default function ScenarioEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const fetchScenario = useRequester<ScenarioResource>({
    onSubmit: (id) => ScenarioResource.fetchOne(id),
    onError: console.log,
  });

  const fetchParticipants = useRequester<ParticipantResource[]>({
    onSubmit: () => ParticipantResource.fetchMany(),
    onError: console.log,
  });

  const saveScenario = useRequester<ScenarioResource>({
    onSubmit: (data: any) =>
      id ? ScenarioResource.updateOne(id, data) : ScenarioResource.createOne(data),
    onSuccess: (ob) => navigate(`/scenarios/${ob.data.id}`),
    onError: console.log,
  });

  useEffect(() => {
    id && fetchScenario.submit(id);
    fetchParticipants.submit();
  }, [id]);

  let scenario;
  if (id) scenario = ScenarioResource.get(id).data as ScenarioData;

  if (id && !scenario) {
    return (
      <Page>
        <Page.Content>
          <Box className="flex flex-col items-center h-full justify-center">
            <CircularProgress />
          </Box>
        </Page.Content>
      </Page>
    );
  }

  return (
    <Page>
      <Page.Header>
        <Box className="flex flex-col h-full">
          <Typography variant="body1" color="text.secondary" sx={{ mt: 8 }}>
            👋 Hey, {user?.data.firstName}!
          </Typography>
          <Typography variant="h1">
            {id ? `Edit Scenario: ${scenario?.title}` : 'New Scenario'}
          </Typography>
          <Box className="flex-grow"></Box>
        </Box>
      </Page.Header>
      <Page.Content>
        <Box sx={{ mt: 5 }}>
          <ScenarioForm
            data={scenario}
            onSubmit={saveScenario.submit}
            saving={saveScenario.loading}
            error={saveScenario.error}
            onCancel={() => navigate(id ? `/scenarios/${id}` : '/scenarios')}
          />
        </Box>
      </Page.Content>
    </Page>
  );
}
